import IpcRouter from '@shared/ipc/IpcRouter.ts'

export interface ClaudeCodeHooksStatus {
  installed: boolean
}

export interface ApiServerInfo {
  port: number
  pid: number
}

export interface ClaudeCodeIpcRouterType {
  installHooks: () => Promise<ClaudeCodeHooksStatus>
  uninstallHooks: () => Promise<ClaudeCodeHooksStatus>
  getHooksStatus: () => Promise<ClaudeCodeHooksStatus>
  getApiServerInfo: () => Promise<ApiServerInfo | null>
}

/** GlobalState key holding the list of Claude Code session IDs currently tracked by the main process. */
export const TRACKED_CC_SESSION_IDS_KEY = 'claudeCodeSessionTracker.trackedSessionIds'

class ClaudeCodeIpcRouter extends IpcRouter<ClaudeCodeIpcRouterType> {
  constructor() {
    super('claude-code', {
      installHooks: true,
      uninstallHooks: true,
      getHooksStatus: true,
      getApiServerInfo: true,
    })
  }
}

export default ClaudeCodeIpcRouter
